export * from './sZZA001A.service';
import { SZZA001AService } from './sZZA001A.service';
export * from './sZZA002A.service';
import { SZZA002AService } from './sZZA002A.service';
export * from './sZZA004A.service';
import { SZZA004AService } from './sZZA004A.service';
export * from './sZZA005A.service';
import { SZZA005AService } from './sZZA005A.service';
export * from './sZZA006A.service';
import { SZZA006AService } from './sZZA006A.service';
export * from './sZZA007A.service';
import { SZZA007AService } from './sZZA007A.service';
export * from './sZZA008A.service';
import { SZZA008AService } from './sZZA008A.service';
export * from './sZZA009A.service';
import { SZZA009AService } from './sZZA009A.service';
export * from './sZZA010A.service';
import { SZZA010AService } from './sZZA010A.service';
export * from './sZZA011A.service';
import { SZZA011AService } from './sZZA011A.service';
export * from './sZZA012A.service';
import { SZZA012AService } from './sZZA012A.service';
export * from './sZZA016A.service';
import { SZZA016AService } from './sZZA016A.service';
export * from './sZZA017A.service';
import { SZZA017AService } from './sZZA017A.service';
export * from './sZZA018A.service';
import { SZZA018AService } from './sZZA018A.service';
export * from './sZZA019A.service';
import { SZZA019AService } from './sZZA019A.service';
export * from './sZZA020A.service';
import { SZZA020AService } from './sZZA020A.service';
export * from './sZZA021A.service';
import { SZZA021AService } from './sZZA021A.service';
export * from './sZZA022A.service';
import { SZZA022AService } from './sZZA022A.service';
export * from './sZZA023A.service';
import { SZZA023AService } from './sZZA023A.service';
export * from './sZZA024A.service';
import { SZZA024AService } from './sZZA024A.service';
export * from './sZZA025A.service';
import { SZZA025AService } from './sZZA025A.service';
export * from './sZZA026A.service';
import { SZZA026AService } from './sZZA026A.service';
export * from './sZZA027A.service';
import { SZZA027AService } from './sZZA027A.service';
export * from './sZZA028A.service';
import { SZZA028AService } from './sZZA028A.service';
export * from './sZZA029A.service';
import { SZZA029AService } from './sZZA029A.service';
export * from './sZZA030A.service';
import { SZZA030AService } from './sZZA030A.service';
export * from './sZZA031A.service';
import { SZZA031AService } from './sZZA031A.service';
export * from './sZZA911A.service';
import { SZZA911AService } from './sZZA911A.service';
export * from './sZZA912A.service';
import { SZZA912AService } from './sZZA912A.service';
export * from './sZZA913A.service';
import { SZZA913AService } from './sZZA913A.service';
export * from './sGKZ010A.service';
import { SGKZ010AService } from './sGKZ010A.service';
export * from './sGKZ011A.service';
import { SGKZ011AService } from './sGKZ011A.service';
export * from './sGKZ020A.service';
import { SGKZ020AService } from './sGKZ020A.service';
export * from './sGKZ021A.service';
import { SGKZ021AService } from './sGKZ021A.service';
export * from './sGKZ022A.service';
import { SGKZ022AService } from './sGKZ022A.service';
export * from './sGKZ030A.service';
import { SGKZ030AService } from './sGKZ030A.service';
export * from './sGKZ012A.service';
import { SGKZ012AService } from './sGKZ012A.service';
export const APIS_SHARED = [SZZA001AService, SZZA002AService, SZZA004AService, SZZA005AService, SZZA006AService, SZZA007AService, SZZA008AService, SZZA009AService, SZZA010AService, SZZA011AService, SZZA012AService, SZZA016AService, SZZA017AService, SZZA018AService, SZZA019AService, SZZA020AService, SZZA021AService, SZZA022AService, SZZA023AService, SZZA024AService, SZZA025AService, SZZA026AService, SZZA027AService, SZZA028AService, SZZA029AService, SZZA030AService, SZZA031AService, SZZA911AService, SZZA912AService, SZZA913AService, SGKZ010AService, SGKZ011AService, SGKZ020AService, SGKZ021AService, SGKZ022AService, SGKZ030AService, SGKZ012AService];
